import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {setSelectedPulledElements} from 'actions/index.js';

const PulledBackground = ({selection}) => { 
   
    return (
        <div
          className="pulled-background">
          {selection && selection.x2 - selection.x1 > 0 &&
           <div
           style={{
               left: selection.x1,
               top: selection.y1,
               width: selection.x2 - selection.x1,
               height: selection.y2 - selection.y1,
           }}
             className="selection"/>}
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedPulledElements: x => dispatch(
          setSelectedPulledElements(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PulledBackground);
